import { ListRendererConfig } from '../models/list-renderer-config.model';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable, Subject, take } from 'rxjs';
import { ListRendererState } from '../state/list-renderer.state';

@Injectable({
  providedIn: 'root',
})
export class ListRendererService {
  public readonly saveDefaultPage = new BehaviorSubject<boolean>(false);
  private _refreshTable = new Subject<{ saveCurrentPage: boolean }>();

  constructor(private store: Store) {}

  public getRefreshTable(): Observable<{ saveCurrentPage: boolean }> {
    return this._refreshTable.asObservable();
  }

  public refreshTable(saveCurrentPage: boolean = false): void {
    this.saveDefaultPage.next(saveCurrentPage);
    this._refreshTable.next({ saveCurrentPage });
  }

  public getListConfigByKey(key: string): Observable<ListRendererConfig> {
    return this.store.select(ListRendererState.configurationByKey(key)).pipe(take(1));
  }

  public setDefaults(): void {
    this.saveDefaultPage.next(false);
  }
}
